import { createContext, useContext } from 'react';

/**
 * País que se está configurando. El administrador comercial configura los tres países, así que no siempre es el
 * país del usuario: lo elige en el encabezado de la configuración y todas las pestañas lo leen de aquí.
 */
export const PaisConfiguracionContext = createContext<number | undefined>(undefined);

export const usePaisConfiguracion = () => useContext(PaisConfiguracionContext);
